import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
  Legend,
} from "recharts";
import { monthYearLabel, fullDateLabel, monthlyTicks } from "../../lib/indicators";

const COLORS = [
  "oklch(0.52 0.105 223.128)", // main (primary)
  "oklch(0.6 0.18 145)",
  "oklch(0.55 0.21 25)",
  "oklch(0.45 0.13 280)",
];

/**
 * series: [{ ticker, company_name, is_main, data: [{quote_date, value}] }]
 * Value is normalized to 100 at the first point.
 */
export default function ComparisonChart({ series }) {
  if (!series || !series.length) return null;
  const dateMap = new Map();
  series.forEach((s) => {
    s.data.forEach((p) => {
      const key = p.quote_date;
      if (!dateMap.has(key)) dateMap.set(key, { raw_date: key });
      dateMap.get(key)[s.ticker] = p.value;
    });
  });
  const merged = Array.from(dateMap.values()).sort((a, b) => a.raw_date.localeCompare(b.raw_date));
  const ticks = monthlyTicks(merged);

  return (
    <div className="space-y-2">
      <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
        Comparativo setorial · base 100
      </div>
      <div className="h-[260px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={merged} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(0.92 0.004 286.32)" vertical={false} />
            <XAxis dataKey="raw_date" ticks={ticks} tickFormatter={monthYearLabel} interval={0} tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" />
            <YAxis tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" width={45} />
            <Tooltip
              contentStyle={{ background: "var(--popover)", border: "1px solid var(--border)", fontSize: 12 }}
              labelFormatter={fullDateLabel}
              formatter={(v) => Number(v).toFixed(2)}
            />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <ReferenceLine y={100} stroke="oklch(0.552 0.016 285.938)" strokeDasharray="2 4" />
            {series.map((s, idx) => (
              <Line
                key={s.ticker}
                type="monotone"
                dataKey={s.ticker}
                stroke={COLORS[idx % COLORS.length]}
                strokeWidth={s.is_main ? 2.4 : 1.4}
                strokeDasharray={s.is_main ? "" : "3 3"}
                dot={false}
                isAnimationActive={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
